import React, { useEffect, useState } from 'react';
import { useBlocker, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import ConfirmationDialog from '../Form/ConfirmationDialog';
import { addLogoutBlocker, removeLogoutBlocker } from '../../../screens/Login/actions';

const CommonNavigationPrompt = ({
    when,
    bodyText = 'You have unsaved changes. Do you want to leave and discard your changes?',
    submitLabel = 'Yes',
    cancelLabel = 'No',
    customOnConfirm,
    customOnSubmit,
  }) => {
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [location, setLocation] = useState(currentLocation);
  const [logoutBlockerResolver, setLogoutBlockerResolver] = useState(null);

  useEffect(() => {
    if (!when && isOpen) {
      setIsOpen(false);
    }

    const closeHandle = (event) => {
      if (when) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    const logoutBlocker = () => {
      const promise = new Promise((resolve) => {
        setLogoutBlockerResolver(() => resolve);
      });

      setIsOpen(true);
    
      return promise;
    };

    window.addEventListener('beforeunload', closeHandle);
    if (when) {
      dispatch(addLogoutBlocker(logoutBlocker));
    }

    return () => {
      window.removeEventListener('beforeunload', closeHandle);

      dispatch(removeLogoutBlocker(logoutBlocker));
    };
  }, [when]);

  const shouldBlock = React.useCallback(
    ({ currentLocation, nextLocation }) => {
        if (when) {
          if (
            (!location || nextLocation.pathname !== location.pathname)
            && currentLocation.pathname !== nextLocation.pathname
          ) {
            setLocation(nextLocation);
            setIsOpen(true);

            return true;
          }
        }

        return false;
    },
    [when]
  );

  const blocker = useBlocker(shouldBlock);

  const submitHandler = () => {
    if (blocker.state === 'blocked') {
      blocker.proceed();
    }

    logoutBlockerResolver && logoutBlockerResolver(false);

    customOnConfirm && customOnConfirm();
    navigate(location.pathname, { replace: true });
    setIsOpen(false);
  };

  const cancelHandler = () => {
    logoutBlockerResolver && logoutBlockerResolver(true);
    customOnSubmit && customOnSubmit();
    setIsOpen(false);
  };

  return (
    <ConfirmationDialog
      open={isOpen}
      bodyText={bodyText}
      submitLabel={submitLabel}
      cancelLabel={cancelLabel}
      onSubmit={submitHandler}
      onCancel={cancelHandler}
    />
  );
};

export default CommonNavigationPrompt;
